export default __webpack_public_path__ + "static/media/hip.b4486678.png";